module.exports = __webpack_public_path__ + "static/CovidGlobal-a38603e6f2aa4c068400c7abcacf96a7.png";